import React, { Component } from 'react';
import * as LabelByLocationAction from '../actions/LabelByLocationAction';
import LabelByLocationStore from '../stores/LabelByLocationStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import { saveAs } from 'file-saver';
import Chip from '@material-ui/core/Chip';
import BreadCrumpData from '../stores/BreadCrumpStore';
import * as MenuAction from '../actions/MenuAction'
import { TextField } from '@material-ui/core';
import * as XLSX from "xlsx";

import swal from 'sweetalert';
import { textAlign } from '@material-ui/system';
let allRecord=false;
let currentPagePath;
const styles = {
    chip: {
        overflow: 'hidden',
    },
};
class LabelByPrintingComponent extends Component {
    constructor(props) {
        super(props);
        const { valueStrings } = props;
        allRecord = false;
        //const { PDFImageIds } = props;
        //const IdsArray = [];
        this.state = {

            Type: "",
            AreaSelected: "",
            AisleSelected: "",
            RowSelected: "",
            ShelfSelected: "",
            BinSelected: "",

            CribDD: [],
            AreaDD: [],
            AisleDD: [],
            RowDD: [],
            ShelfDD: [],
            BinDD: [],
            PageLoadData: [],
            GridData: [],
            pageCount: "",
            pageNo: "1",
            CheckedGrid: [],
            ItemIdList: [],
            ItemId: "",
            SelectedId: "",
            chipArray: [],
            PageLoadResponse: [],
            ItemSearchArray: [],
            checkedGridArr: [],
            labelCount: "1",
            SelectAll: true,
            FilterData: [],
            itemvalue: []


        }
    }
    componentDidMount() {

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.PageLoad();
        LabelByLocationStore.on('LabelPageLoad', this.PageLoadResponse);
        LabelByLocationStore.on('GridDataBind', this.SearchDataResponse);
        LabelByLocationStore.on('ActiveFlag', this.ActiveFlagUpdateResponse);
        LabelByLocationStore.on("PrintItem", this.printSelectedItemResonse);
        LabelByLocationStore.on("Label_CurrentFavPage", this.loadFavPageResponse.bind(this));
        LabelByLocationStore.on("Label_InsertFavPage", this.updateFavPageResponse.bind(this));
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        LabelByLocationAction.getCurrentFavPage(getFavPageBO);


    }
    componentWillUnmount() {
        LabelByLocationStore.removeListener('LabelPageLoad', this.PageLoadResponse);
        LabelByLocationStore.removeListener('GridDataBind', this.SearchDataResponse);
        LabelByLocationStore.removeListener('ActiveFlag', this.ActiveFlagUpdateResponse);
        LabelByLocationStore.removeListener("PrintItem", this.printSelectedItemResonse);
        LabelByLocationStore.removeListener("Label_CurrentFavPage", this.loadFavPageResponse.bind(this));
        LabelByLocationStore.removeListener("Label_InsertFavPage", this.updateFavPageResponse.bind(this));

    }

    PageLoad = () => {


        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        //console.log("DeepthiConsole", CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"));
        if (cribID == null || cribID == undefined || cribID == "" || cribID == " ") {

            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        else {
            let PageLoadBO = {
                //Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                CribID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            LabelByLocationAction.PageLoad(PageLoadBO);

        }
    }
    PageLoadResponse = () => {
        
        let PageLoadResponse = JSON.parse(LabelByLocationStore.PageLoadData);
        let Dropdowns = PageLoadResponse.Table;
        let AreaDD = [];
        if (Dropdowns == undefined) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in Retriving the data"
            });
        }
        else {

            let DuplicateArea = Dropdowns.filter((v, i, a) => a.findIndex(t => (t.STORAGE_AREA === v.STORAGE_AREA)) === i)
            DuplicateArea.map((item, index) => {
                let obj = {
                    value: item.STORAGE_AREA,
                    label: item.STORAGE_AREA
                };
                AreaDD.push(obj)


            })
        }


        this.setState({ AreaDD: AreaDD, PageLoadResponse: Dropdowns })
    }
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ pageNo: pageNo });
    }
    handleFavorite = (event) => {
        
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Labels by Location",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            LabelByLocationAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            LabelByLocationAction.deleteFavPage(deleteFavPageBO)
        }
    };
    SearchDataResponse = () => {

        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let PageLoadResponse = JSON.parse(LabelByLocationStore.GridLoadData);
        let GridLoadData = PageLoadResponse.Table;
        GridLoadData.forEach((value, index) => {
            GridLoadData[index].isChecked = false;
        })
        if (GridLoadData == undefined || GridLoadData.length == 0 || GridLoadData == null) {

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "No Records Found"
            });

        }

        console.log("GridLoadData", GridLoadData);
        this.setState({ GridData: GridLoadData, allRecord: GridLoadData, pageCount: parseFloat(GridLoadData.length) / 10, checkedGridArr: [], FilterData: GridLoadData });

    }

    // handleLabelCount = (event) => {
    //    let min = 1;
    //    let max = 100;
    //    const value = Math.max(min, Math.min(max, Number(event.target.value)));
    //     this.setState({ labelCount:value})
    //};

    exportToExcel = () => {

        // Regression Bug- 5476 - K. Surya - Walmart_ Labels by location_ When user clicks select all locations button the checkbox is selected and disabled.

        let GridData = this.state.GridData.filter(item => item.isChecked === true);
       
            
           
        const worksheet = XLSX.utils.json_to_sheet(GridData.map((item, index) => ({
         
                "ItemID": item.INV_ITEM_ID,
                "Description": item.DESCR,
                "BinLocation": item.BINLOCATION,
                "Crib": item.CRIB,
                "Quantity": item.QTY,
                "Barcode ID": item.BARCODE_ID,
                "Active_Flag": item.EFF_STATUS,
                "Default Location": item.DEFAULT_LOC
          
            


        })));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'LabelsByLocation');
        XLSX.writeFile(workbook, 'LabelsByLocationReport.xlsx');
    };

    // Regression Bug - 5446 Should restrict entering any special characters in input field - Surya K -12/10/2024 
    keyPressQTY(e) {
        const invalidChars = [".", "-", "+", "e"];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };

    handleChangeLabelCount = (e) => {
        let re = SDIConstants.quantityRegEX;
        if (e.target.value == "") {
            this.setState({ labelCount: "1" })
        }
        else if (re.test(e.target.value)) {
            let maxLength = parseInt(e.target.value);
            if ((maxLength < 51 || e.target.value == "") && maxLength != 0 && e.target.value != "-" && e.target.value != "e") {
                this.setState({ labelCount: e.target.value })
            }
        }


    }
    //handleChangeLabelCount = (e) => {
    //    if (e.target.value =="") {
    //        this.setState({ labelCount: "1" })
    //    }
    //    else {
    //        this.setState({ labelCount: e.target.value })
    //    }
    //}
    dropDownhandlechange = (e, type) => {
        let area = ""

        switch (type) {
            case "Area": {
                let aisleDD = [];

                let areaSelected = e
                document.getElementById('ErrorLabel2').innerText = ""
                this.state.PageLoadResponse.map((item, index) => {

                    if (item.STORAGE_AREA == e.value && aisleDD.indexOf(item.STOR_LEVEL_1) == -1) {
                        let obj = {
                            value: item.STOR_LEVEL_1,
                            label: item.STOR_LEVEL_1
                        }
                        aisleDD.push(obj);
                    }
                })
                let dd = aisleDD.filter((ele, ind) => ind === aisleDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({
                    AisleDD: dd, AreaSelected: areaSelected, ShelfDD: [], RowDD: [], BinDD: [],
                    AisleSelected: "",
                    RowSelected: "",
                    ShelfSelected: "",
                    BinSelected: "", ItemSearchArray: []
                })
                break;
            }
            case "Aisle": {
                let RowDD = [];
                let aisleSelected = e
                document.getElementById('ErrorLabel2').innerText = ""
                this.state.PageLoadResponse.map((item, index) => {

                    if (item.STOR_LEVEL_1 == e.value && RowDD.indexOf(item.STOR_LEVEL_2) == -1) {
                        let obj = {
                            value: item.STOR_LEVEL_2,
                            label: item.STOR_LEVEL_2
                        }
                        RowDD.push(obj);
                    }
                })
                let dd = RowDD.filter((ele, ind) => ind === RowDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({
                    RowDD: dd, AisleSelected: aisleSelected, ShelfDD: [], BinDD: [],
                    RowSelected: "",
                    ShelfSelected: "",
                    BinSelected: "",
                })
                break;
            }
            case "Row": {
                let ShelfDD = [];
                let rowSelected = e
                this.state.PageLoadResponse.map((item, index) => {

                    if (item.STOR_LEVEL_2 == e.value && ShelfDD.indexOf(item.STOR_LEVEL_3) == -1) {
                        let obj = {
                            value: item.STOR_LEVEL_3,
                            label: item.STOR_LEVEL_3
                        }
                        ShelfDD.push(obj);
                    }
                })
                let dd = ShelfDD.filter((ele, ind) => ind === ShelfDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({
                    ShelfDD: dd, RowSelected: rowSelected, BinDD: [],
                    ShelfSelected: "",
                    BinSelected: "",
                })
                break;
            }
            case "Shelf": {
                let binDD = [];
                let shelfSelected = e
                this.state.PageLoadResponse.map((item, index) => {

                    if (item.STOR_LEVEL_3 == e.value && binDD.indexOf(item.STOR_LEVEL_4) == -1) {
                        let obj = {
                            value: item.STOR_LEVEL_4,
                            label: item.STOR_LEVEL_4
                        }
                        binDD.push(obj);
                    }
                })
                let dd = binDD.filter((ele, ind) => ind === binDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({
                    BinDD: dd, ShelfSelected: shelfSelected,
                    BinSelected: "",
                })
                break;
            }
            case "Bin": {

                let binSelected = e

                this.setState({ BinSelected: binSelected })
                break;
            }
        }
    }

    sort = (Arr, indexval, nextindexval, Type) => {
        let temp = []
        let size = Arr.length
        let i, j = 0;

        if (Type == "ASC") {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) > eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        } else {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) < eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        }
    }


    SortClick = (event, sortBy, columnName) => {
        
        let MatGrid = this.state.GridData;
        let data = [];
        console.log("MatGrid", MatGrid)
        if (sortBy == "ASC") {

            switch (columnName) {
                case "Itemid": {
                    data = this.sort(MatGrid, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "ASC")

                    break;
                }
                case "binlocation": {
                    data = this.sort(MatGrid, "Arr[i].BINLOCATION", "Arr[j].BINLOCATION", "ASC")
                    //MatGrid.sort(function (a, b) {
                    //    var textA = a.BINLOCATION.toUpperCase();
                    //    var textB = b.BINLOCATION.toUpperCase();
                    //    return (textA > textB) ? 1 : -1;
                    //});
                    break;
                }

            }

        }
        else {
            switch (columnName) {
                case "Itemid": {
                    data = this.sort(MatGrid, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "DESC")
                    //MatGrid.sort(function (a, b) {
                    //    var textA = a.INV_ITEM_ID.toUpperCase();
                    //    var textB = b.INV_ITEM_ID.toUpperCase();
                    //    return (textA > textB) ? -1 : 1;
                    //});
                    break;
                }
                case "binlocation": {
                    data = this.sort(MatGrid, "Arr[i].BINLOCATION", "Arr[j].BINLOCATION", "DESC")
                    // MatGrid.sort((a, b) => a.STOR_LEVEL_2 > b.STOR_LEVEL_2 ? -1 : 1)
                    //MatGrid.sort(function (a, b) {
                    //    var textA = a.BINLOCATION.toUpperCase();
                    //    var textB = b.BINLOCATION.toUpperCase();
                    //    return (textA > textB) ? -1 : 1;
                    //});
                    break;
                }

            }
            // MatGrid.sort((a, b) => a.columnName > b.columnName ? -1 : 1);
        }

        this.setState({ GridData: data });
    };
    loadFavPageResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let favPageResponse = JSON.parse(LabelByLocationStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (LabelByLocationStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(LabelByLocationStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(LabelByLocationStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    searchOnClick = (type) => {


        if (this.state.AreaSelected.value != undefined || this.state.ItemSearchArray.length > 0) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            document.getElementById('ErrorLabel2').innerText = ""
            let LoadDataBO = {
                ItemID: this.state.ItemSearchArray,
                strType: type,
                Crib_ID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
                Area: this.state.AreaSelected.value != undefined ? this.state.AreaSelected.value : "",
                Aisle: this.state.AisleSelected.value != undefined ? this.state.AisleSelected.value : "",
                Row: this.state.RowSelected.value != undefined ? this.state.RowSelected.value : "",
                Shelf: this.state.ShelfSelected.value != undefined ? this.state.ShelfSelected.value : "",
                Bin: this.state.BinSelected.value != undefined ? this.state.BinSelected.value : ""
            }
            LabelByLocationAction.GridDataBind(LoadDataBO);
        }
        else {

            document.getElementById('ErrorLabel2').innerText = "Please Select BinLocation or Enter ItemID "
        }
        this.setState({
            GridData: [], FilterData: [], SelectAll: true, pageNo: "1",
        });
    }


    handleItemIDChange = (event) => {
        if (event.target.value == "") {
            this.setState({
                ItemSearchArray: [], AisleDD: [], RowDD: [], ShelfDD: [], BinDD: [], AreaSelected: "", AisleSelected: "",
                RowSelected: "",
                ShelfSelected: "",
                BinSelected: "",
            });
        }
        else {
            const inputString = event.target.value;
            const splitArray = inputString.split(',');

            document.getElementById('ErrorLabel2').innerText = "";
            const trimmedArray = splitArray.map((chip) => chip.trim());

            this.setState({
                ItemSearchArray: trimmedArray,
            });

        }
        this.setState({
            AisleDD: [], RowDD: [], ShelfDD: [], BinDD: [], AreaSelected: "", AisleSelected: "",
            RowSelected: "",
            ShelfSelected: "",
            BinSelected: "",
        });
    }

    //handleDeleteChip = (chipToDelete) => {
    //    const filteredArray = this.state.ItemSearchArray.filter((chip) => chip !== chipToDelete);
    //    this.setState({ ItemSearchArray: filteredArray });

    //}
    activeFlagUpdate = (index, obj) => {
        let { GridData } = this.state;
        GridData[index].EFF_STATUS = GridData[index].EFF_STATUS == "True" ? "False" : "True";
        this.setState(GridData);
        let ActiveFlag = false;
        let barcodeid = ""
        this.state.GridData.map((item, indxe) => {
            if (indxe == index) {

                // ActiveFlag = item.EFF_STATUS;
                barcodeid = item.BARCODE_ID

            }

        })
        let activeflag = GridData[index].EFF_STATUS == "True" ? true : false;
        let ActiveFlagUpdateBO = {
            ActiveFlag: activeflag,
            BarcodeID: barcodeid
        };

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        LabelByLocationAction.activeFlageUpdate(ActiveFlagUpdateBO);
    }
    ActiveFlagUpdateResponse = () => {
        let data = JSON.parse(LabelByLocationStore.ActiveFlagUpdate);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let result = data.Table1[0].lblDBErr1
        if (result == "Success") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Active Flag updated successfully"
            });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in Updating ActiveFlag"
            });
        }
    }




    btnselectLocationsOnClick = (index, obj) => {
        let localChck = this.state.checkedGridArr;
        let { GridData } = this.state;
        GridData[index].isChecked = GridData[index].isChecked == true ? false : true;
        this.setState(GridData);

        if (GridData[index].isChecked == true) {
            document.getElementById('ErrorLabel').innerText = " "
            document.getElementById('ErrorLabel2').innerText = " "
            this.state.GridData.map((item, indxe) => {
                if (indxe == index) {
                    let obj =
                    {
                        Item_ID: item.INV_ITEM_ID,
                        Description: item.DESCR,
                        BinLocation: item.BINLOCATION,
                        MFGItemId: item.MFG_ITM_ID,
                        MFGId: item.MFG_ID,
                        UnitOfMeasure: item.QTY,
                        barcodeid: item.BARCODE_ID,
                        cribID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")

                    }
                    localChck.push(obj)
                }
            })
        }


        else if (GridData[index].isChecked == false) {

            localChck = this.state.checkedGridArr.filter(item => item.Item_ID != obj.INV_ITEM_ID);


        }
        this.setState({ checkedGridArr: localChck, SelectAll: localChck.length == this.state.GridData.length ? false: true });
    };
    ClearOnclick = () => {
        this.setState({
            ItemSearchArray: [], AreaSelected: "", AisleSelected: "",
            RowSelected: "",
            ShelfSelected: "",
            BinSelected: "", AisleDD: [], ShelfDD: [], BinDD: [], RowDD: []
        });
    }
    btnselectLocItemsOnClick = (type) => {
        let localChck = []
        document.getElementById('ErrorLabel').innerText = ""
        switch (type) {
            case "SelectAll": {
                let GridData = this.state.GridData
                GridData.forEach((item, i) => {

                    GridData[i].isChecked = true
                    let obj =
                    {
                        Item_ID: item.INV_ITEM_ID,
                        Description: item.DESCR,
                        BinLocation: item.BINLOCATION,
                        MFGItemId: item.MFG_ITM_ID,
                        MFGId: item.MFG_ID,
                        UnitOfMeasure: item.QTY,
                        barcodeid: item.BARCODE_ID,
                        cribID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")


                    }
                    localChck.push(obj)

                })
                this.setState({ checkedGridArr: localChck, SelectAll: false, pageCount: parseFloat(GridData.length) / 10, GridData: GridData });
                break;
            }
            case "ActiveLoc": {
                let griddataFilter = this.state.GridData.filter(item => item.EFF_STATUS == "True");
                let GridData = this.state.GridData;
                allRecord = true;
                if (griddataFilter.length > 0) {
                    GridData.forEach((item, i) => {

                        if (GridData[i].EFF_STATUS == "True") {


                            GridData[i].isChecked = true
                            let obj =
                            {
                                Item_ID: item.INV_ITEM_ID,
                                Description: item.DESCR,
                                BinLocation: item.BINLOCATION,
                                MFGItemId: item.MFG_ITM_ID,
                                MFGId: item.MFG_ID,
                                UnitOfMeasure: item.QTY,
                                barcodeid: item.BARCODE_ID,
                                cribID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")

                            }
                            localChck.push(obj)
                        }
                    })
                    this.setState({ GridData: GridData, checkedGridArr: localChck, SelectAll: false, pageCount: parseFloat(griddataFilter.length) / 10, FilterData: griddataFilter, GridData: griddataFilter });

                }
                else {
                    this.setState({ SelectAll: true, FilterData: GridData });
                    break;
                }
                break;
            }
            case "UnSelect": {
                let GridData;
                if (allRecord === true) {
                     GridData=this.state.allRecord
                } else {
                   GridData = this.state.GridData
                }
                
                GridData.forEach((x, i) => {

                    GridData[i].isChecked = false

                })
                localChck = []
                this.setState({ GridData: GridData});
                this.setState({ checkedGridArr: localChck, FilterData: GridData, SelectAll: true, pageCount: parseFloat(GridData.length) / 10 });
                break;
            }

        }

    }


    //printSelectedItems = () => {
    //    if (this.state.checkedGridArr.length > 0) {
    //        let PrintItemBO = {
    //            ItemDetail: this.state.checkedGridArr,
    //            LabelCount: 3,
    //            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT")

    //        };
    //        LabelByLocationAction.printSelectedItem(PrintItemBO);
    //    }
    //    else {
    //        document.getElementById('ErrorLabel').innerText = "Select the Items to Print"
    //    }

    //}
    printSelectedItemResonse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PrintResponse = LabelByLocationStore.printitem
        if (PrintResponse == "Fail") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in Printing Labels"
            })
        }
        else if (PrintResponse == "Success") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Printed Successfully"
            })
            // Regression bug- 5477 - K. Surya  - Walmart_ Labels by location_ When user clicks select all locations button the checkbox is selected and disabled.
            this.btnselectLocItemsOnClick("UnSelect")
        }
        else if (PrintResponse == "Printer unavailable") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Printer unavailable"
            })

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue PLease contact SDI"
            })

        }
    }


    printSelectedItems = () => {
        if (this.state.checkedGridArr.length > 0) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let PrintItemBO = {
                ItemDetail: this.state.checkedGridArr,
                LabelCount: this.state.labelCount > 0 ? this.state.labelCount : 1,
                UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            LabelByLocationAction.printSelectedItem(PrintItemBO);
        }
        else {
            document.getElementById('ErrorLabel').innerText = "Select the Items to Print"
        }

    }



    BindGridData = () => {
        if (this.state.FilterData.length > 0) {
            return this.state.FilterData.map((value, index) => {
                
                let check = value.isChecked;
                //let tl_cost = Math.round(parseFloat(value.TL_COST), 2);
                //let ext_cost = Math.round(parseFloat(value.EXT_COST), 2)
                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                    
                    return (<React.Fragment key={index}>
                        <tr>
                            <td style={{ textAlign: "center" }}>

                                <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block">
                                    <input type="checkbox" className="custom-control-input" id={`Checkedgrid_${index}`} name="checkgrid12" checked={value.isChecked} onClick={(e) => this.btnselectLocationsOnClick(index, value)} />
                                    <label className={`custom-control-label priority-checkbox profile-update-checkbox`} htmlFor={`Checkedgrid_${index}`}></label>
                                </div>
                            </td>
                            <td >{value.BINLOCATION}</td>
                            <td > {value.CRIB}</td>
                            <td >{value.INV_ITEM_ID}</td>
                            <td> {value.DESCR}</td>
                            <td >{value.QTY}</td>
                            <td >{value.BARCODE_ID}</td>
                            <td style={{ textAlign: "center" }}>
                                <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block" style={{ marginLeft: '2%' }}>
                                    <input type="checkbox" className="custom-control-input" id={`qtyonhand_${index}`} name="example4" checked={value.EFF_STATUS == "True" ? true : false} onClick={(e) => this.activeFlagUpdate(index, value)} />
                                    <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor={`qtyonhand_${index}`}></label>
                                </div>
                            </td>
                            <td style={{ textAlign: "center" }}> <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block" style={{ marginLeft: '2%' }}>
                                <input disabled={true} type="checkbox" className="custom-control-input " disabled="true" id="qtyonhandid" name="example4" checked={value.DEFAULT_LOC == "True" ? true : false} />
                                <label className="custom-control-label priority-checkbox profile-update-checkbox  custombtn-disabled" htmlFor="qtyonhandid"></label>

                            </div>
                            </td>

                        </tr>

                    </React.Fragment>

                    );
                }
            })
        }
        else {
            return (
                <section className="site-undercontruction container text-center center-panel pt-4">
                    <div className="img-section">
                        <img src="images/nosearch.jpg" alt="imagefile" />
                    </div>
                    <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                    </p>
                </section>);
        }
    }



    render() {
        return (
            <><div className="container-fluid content-section content-margin" style={{ marginTop: "174px" }}>
                <div className="row">
                    {/* Title - Starts here */}
                    <>
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title">Labels by Location</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-Fav">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    </>

                    {/* Title - Ends here */}
                    {/* Filter Component - Starts here */}
                    <div className="col-md-12 border-bottom pb-3 mb-3">
                        <h5 className="page-title border-0 font-18">Bin Location Search</h5>
                        <div className="sdi-display mb-3">
                            <div className="sdi-wid-20 mb-3 pr-3">
                                <div className="row align-items-center">
                                    <label className="col-md-2 pr-0 catalog-label form-label">Area</label>
                                    <div className="col-md-10" style={{ fontSize: "13px" }}>
                                        <Select

                                            id="labelselctarea"
                                            name="labelarea"
                                            onChange={(e) => this.dropDownhandlechange(e, "Area")}
                                            value={this.state.AreaSelected}
                                            options={this.state.AreaDD}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="sdi-wid-20 mb-3 pr-3">
                                <div className="row align-items-center">
                                    <label className="col-md-2 pr-0 catalog-label form-label">
                                        Aisle
          </label>
                                    <div className="col-md-10" style={{ fontSize: "13px" }}>
                                        <Select

                                            id="labelasile"
                                            defaultValue="Select"
                                            name="labelasileselect"
                                            onChange={(e) => this.dropDownhandlechange(e, "Aisle")}
                                            value={this.state.AisleSelected}
                                            options={this.state.AisleDD}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="sdi-wid-20 mb-3 pr-3">
                                <div className="row align-items-center">
                                    <label className="col-md-2 pr-0 catalog-label form-label">Row</label>
                                    <div className="col-md-10" style={{ fontSize: "13px" }}>
                                        <Select

                                            id="labelrow"
                                            defaultValue="Select"
                                            name="labelselectrow"
                                            onChange={(e) => this.dropDownhandlechange(e, "Row")}
                                            value={this.state.RowSelected}
                                            options={this.state.RowDD}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="sdi-wid-20 mb-3 pr-3">
                                <div className="row align-items-center">
                                    <label className="col-md-2 pr-0 catalog-label form-label">
                                        Shelf
          </label>
                                    <div className="col-md-10" style={{ fontSize: "13px" }}>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="labelshelf"
                                            defaultValue="Select"
                                            name="labelselect"
                                            onChange={(e) => this.dropDownhandlechange(e, "Shelf")}
                                            value={this.state.ShelfSelected}
                                            options={this.state.ShelfDD}
                                        /></span>



                                    </div>
                                </div>
                            </div>
                            <div className="sdi-wid-20 mb-3">
                                <div className="row align-items-center">
                                    <label className="col-md-2 pr-0 catalog-label form-label">Bin</label>
                                    <div className="col-md-10" style={{ fontSize: "13px" }}>
                                        <Select

                                            id="labelbin"
                                            defaultValue="Select"
                                            name="labelbin"
                                            onChange={(e) => this.dropDownhandlechange(e, "Bin")}
                                            value={this.state.BinSelected}
                                            options={this.state.BinDD}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row align-items-center mb-3">
                            <div className="col-md-5 sdi-border-line d-sm-none d-none d-md-block">
                                <span className="w-100" />
                            </div>
                            <div className="col-md-2 text-center">
                                <label>Or</label>
                            </div>
                            <div className="col-md-5 sdi-border-line d-sm-none d-none d-md-block">
                                <span className=" w-100" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10 col-lg-7 mb-3 pr-3">


                                <div className="row align-items-center">

                                    <label className="mr-2 catalog-label form-label">Item Search</label>
                                    <input
                                        type="text"
                                        className="form-control col-md-8 sdi-margin"
                                        placeholder="Enter item #"
                                        onChange={(e) => this.handleItemIDChange(e)}
                                        value={this.state.ItemSearchArray}
                                    />
                                    {/*  <input
                                        class="form-control col-md-8 sdi-margin"
                                        type="text"
                                        value={this.state.ItemSearchArray}
                                      onChange = {(e)  =>this.handleItemIDChange(e)}
                                       
                                        placeholder="Enter Item ID"
                                    />*/}


                                </div>
                            </div>



                            <span className="px-2 errorspan1 mt-3" id="ErrorLabel2"></span>
                        </div>
                        <div className="text-right">
                            <button className="btn btn-secondary custom-btn-secondary secondary-btn px-3 mr-2" onClick={() => this.ClearOnclick()}>
                                Clear
      </button>
                            <button className="btn btn-primary custom-btn-primary primary-btn mb-0" onClick={() => this.searchOnClick(this.state.ItemSearchArray.length > 0 ? "ITEM" : "BIN")}>
                                Search
      </button>
                        </div>
                    </div>
                </div>

                <>{this.state.FilterData.length > 0 ? <>
                    <div className="col-md-12 my-3">
                        <div className="row justify-content-between m-0">
                            <div className="text-left">
                                {this.state.SelectAll ?
                                    <div>
                                        <button className="btn btn-primary custom-btn-primary primary-btn mr-2 mb-2" onClick={() => this.btnselectLocItemsOnClick("SelectAll")}>
                                            <Trans> Select All Locations </Trans>

                                        </button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn mr-2 mb-2" onClick={() => this.btnselectLocItemsOnClick("ActiveLoc")}>
                                            <Trans> Select Active Locations </Trans>
                                        </button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn mr-2 mb-2" onClick={() => this.exportToExcel()}>
                                            Export to Excel
                                </button></div> :
                                    <div>
                                        <button className="btn btn-primary custom-btn-primary primary-btn mr-2 mb-2" onClick={() => this.btnselectLocItemsOnClick("UnSelect")}>
                                            <Trans>UnSelectAll</Trans>

                                        </button> <button className="btn btn-primary custom-btn-primary primary-btn mr-2 mb-2" onClick={() => this.exportToExcel()}>
                                            Export to Excel
                                </button>
                                    </div>
                                }


                            </div>
                            <div className="text-right">
                                <div className="d-flex">
                                    <div className="text-left">
                                        <label className="font-14 font-regular mr-1">
                                            Number of Labels
            </label>
                                        <input type="number" className="sdi-label-box" min="1" max="50" value={this.state.labelCount} oninput="validity.valid||(value='');" onChange={(e) => this.handleChangeLabelCount(e)} onKeyDown={(e) => this.keyPressQTY(e)} />

                                        <button className="btn btn-primary custom-btn-primary primary-btn mb-2" onClick={() => this.printSelectedItems()}>
                                            Print Selected Items
          </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="px-2 errorspan1 mt-3" id="ErrorLabel"></span>
                    <div className="col-md-12">
                        <p className="font-14 font-regular my-0 mb-3">
                            <span className="info-container pr-1">
                                <img src="images/info-black-icon.svg" alt="Info-icon" />
                            </span>
                            Please select the checkbox to print the item details
    </p>
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="table-responsive table-customstyle-whitespace">
                            <table className="table ZEUS_Grid FOM-grid WOA-grid">
                                <thead>
                                    <tr>
                                        <th className="text-center">Select</th>
                                        <th className="position-sort-icon">
                                            Bin Location
              <span className="sort-up ml-1">
                                                <img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "binlocation")} />
                                            </span>
                                            <span className="sort-down ml-1">
                                                <img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DES", "binlocation")} />
                                            </span>
                                        </th>
                                        <th className="position-sort-icon">
                                            Crib


                                            </th>
                                        <th className="position-sort-icon">
                                            Item ID
              <span className="sort-up ml-1">
                                                <img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "Itemid")} />
                                            </span>
                                            <span className="sort-down ml-1">
                                                <img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DES", "Itemid")} />
                                            </span>
                                        </th>
                                        <th className="position-sort-icon">
                                            Description
            </th>
                                        <th className="position-sort-icon">
                                            Quantity
            </th>
                                        <th className="position-sort-icon">
                                            BarCode ID
            </th>
                                        <th className="text-center position-sort-icon">
                                            Active Flag
            </th>
                                        <th className="text-center position-sort-icon">
                                            Default Location
            </th>
                                    </tr>
                                </thead>
                                {this.state.GridData.length > 0 ? <>
                                    <tbody>
                                        {this.state.GridData.length > 0 ? this.BindGridData() : null}
                                    </tbody>
                                </> : null}

                            </table>
                        </div>
                    </div>
                </> : null}
                    <div className="col-md-12">

                        {this.state.FilterData.length > 0 ?
                            <div className="col-md-12 mb-3 p-0">
                                <span className="total-records mb-2">
                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.FilterData.length}</span>
                                </span>
                                {this.state.FilterData.length > 0 ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'custom-pagination pagination float-right'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.pageNo - 1}
                                /> : null}

                            </div> : null}
                    </div>
                </>

            </div>


            </>


        );
    }

}
export default withTranslation()(LabelByPrintingComponent);